/** Shared interaction rules; numbering is always the configured catalogue order. */
export function bannerIndex(current: number, delta: number, count: number) {
  if (count <= 0) return 0;
  return ((current + delta) % count + count) % count;
}

export function bannerSwipe(start: { x: number; y: number }, end: { x: number; y: number }): -1 | 0 | 1 {
  const x = start.x - end.x;
  const y = start.y - end.y;
  if (Math.abs(x) < 50 || Math.abs(x) <= Math.abs(y) * 1.25) return 0;
  return x > 0 ? 1 : -1;
}